import { render, staticRenderFns } from "./Rob.vue?vue&type=template&id=8966f094&scoped=true"
import script from "./Rob.vue?vue&type=script&lang=js"
export * from "./Rob.vue?vue&type=script&lang=js"
import style0 from "./Rob.vue?vue&type=style&index=0&id=8966f094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8966f094",
  null
  
)

export default component.exports